import auth from "../../utils/auth"
import Axios from "axios"
import { errorHandler } from "../../utils"
import qs from 'query-string'
import api from '../../api'
import adapter from "../resource-form/adapter"
import { TIMEOUT } from "../../constants"

const { getTokenFromLocalStorage } = auth()

function generateHeaders(){
  const token = getTokenFromLocalStorage()
  return token === null ? {
    'X-Api-Key': api.key
  } : {
    'X-Api-Key': api.key,
    'Authorization': `JWT ${token}`
  }
}

const service = {
  async getData(options) {

    function matchQuery(options){
      let query = {}

      if(options){
        if(options.approach){
          query.typeApproach = options.approach
        }
        if(options.issue){
          query.typeIssues = options.issue
        }
        if(options.type){
          query.typeOrganisasi = options.type
        }
        if(options.audience){
          query.typeAudience = options.audience
        }
        if(options.limit){
          query.limit = options.limit
        }
      }

      return query
    }

    const matched = matchQuery(options)
    const stringified = qs.stringify(matched)
    const querystring = `${stringified !== '' ? '?'+stringified : ''}`

    return new Promise(function(resolve, reject){
      Axios.get(`${api.base}${api.resources}${querystring}`, {
        // timeout: TIMEOUT,
        headers: generateHeaders()
      }).then(res => {
        if(res.data){
          if(res.data.results) resolve(res.data.results)
          else resolve(res.data)
        }
        else{
          resolve(res)
        }
      })

      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
    })
  },

  async getDetails({id, lang}) {
    return new Promise(function(resolve, reject){
      Axios.get(`${api.base}${api.resources}${id}/`, {
        timeout: TIMEOUT,
        headers: generateHeaders()
      }).then(res => {
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  async createResource(data){
    console.log('match this structure:', data)

    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      /* Axios */
      Axios.post(api.base+api.resources, requestBody, config)
      .then(res => {
        console.log(res)
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      })
      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
    })
  },

  /**
   * PUT - update Resource
   */
  async updateResource({id, data}){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      let requestBody = adapter.formToRequestBody(data)
      console.log('requestBody', requestBody)

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.resources}${id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
        // resolve()
      } else {
        reject('id not provided.')
      }
    })
  },

  /**
   * PUT - update Resource image
   */
  async updateResourceImage(data){
    return new Promise(function(resolve, reject){
      let requestBody = data.formData
      const config = {
        headers: generateHeaders()
      }

      if(data.id){
        Axios.put(`${api.base}${api.resources}${data.id}/`, requestBody, config)
        .then(res => resolve(res.data ? res.data : res))
        .catch(err => reject(errorHandler(err)));
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateResourceFile(id, formData){
    return new Promise(function(resolve, reject){
      let requestBody = formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateHeaders()
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.resources_file}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
